// Canonical station-to-colour palette. Used by every multi-station chart
// so a station's colour is identical across Home, HFDI trend, YTD rainfall,
// Fire, Station Detail, and any future comparison chart.
//
// Palette is deliberately high-contrast and colour-blind friendly (Okabe–Ito
// inspired): dark navy / orange / teal / red are all distinguishable to
// deuteranopes and protanopes and don't share a red / brown / dark family.
export const STATION_COLORS = {
    malabar:      "#1E3A8A", // dark navy
    franklins:    "#F97316", // orange
    port_clinton: "#0D9488", // teal
    seaview:      "#DC2626", // red
};

// Fallback ring for any station id not in the map above (e.g. new stations
// added later). Chosen to remain visually distinct from the four canonical
// colours.
const FALLBACK = ["#7C3AED", "#CA8A04", "#16A34A", "#DB2777"];

export function stationColor(stationId, fallbackIndex = 0) {
    return STATION_COLORS[stationId] || FALLBACK[fallbackIndex % FALLBACK.length];
}
